import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import Tooltip from '@material-ui/core/Tooltip';

import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import { translate } from 'services/i18nService';
import UserStore from 'stores/UserStore';

import singleCoinImg from '../../../images/chat/single-coin.png';

import styles from './index.css';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

const TokenHolderIndicatorAvatar = (props) => {
  const {
    avatarClassName,
    avatarImageClassName,
    hasTokens,
    isBasicAvatar,
    recentSpendingTier,
    username,
    ...restProps
  } = props;

  const { user: { sfw } } = UserStore;

  const url = `${BASE_URL}/avatar/user/60x60/${username}.jpg`;
  const alt = translate('v2profile.chat.avatar');

  if (isBasicAvatar) {
    const classes = classNames({
      [styles.avatar]: true,
      [styles.blur]: sfw,
      [avatarClassName]: avatarClassName,
    });

    const imageClasses = classNames(
      styles.image,
      avatarImageClassName
    );

    return (
      <div className={classes} {...restProps}>
        <img
          alt={alt}
          className={imageClasses}
          src={url}
        />
      </div>
    );
  }

  const classes = classNames({
    [styles.avatar]: true,
    [styles.blur]: sfw,
    [styles.tierWhite]: recentSpendingTier === 0,
    [styles.tierBlue]: recentSpendingTier === 1,
    [styles.tierPurple]: recentSpendingTier === 2,
    [styles.tierYellow]: recentSpendingTier === 3,
    [styles.tierOrange]: recentSpendingTier === 4,
    [avatarClassName]: avatarClassName,
  });

  const imageClasses = classNames({
    [styles.image]: true,
    [styles.recentSpendingTierBorder]: recentSpendingTier !== undefined,
    [avatarImageClassName]: avatarImageClassName,
  });

  if (hasTokens) {
    return (
      <Tooltip
        arrow={true}
        placement="top"
        title={translate('v2broadcast.user.has.tokens')}
      >
        <div className={classes} {...restProps}>
          <img
            alt={alt}
            className={imageClasses}
            src={url}
          />
          <img
            alt="tokens badge"
            className={styles.hasTokensBadge}
            src={singleCoinImg}
          />
        </div>
      </Tooltip>
    );
  }

  return (
    <div className={classes} {...restProps}>
      <img
        alt={alt}
        className={imageClasses}
        src={url}
      />
    </div>
  );
};

TokenHolderIndicatorAvatar.propTypes = {
  username: PropTypes.string.isRequired,
  avatarClassName: PropTypes.string,
  avatarImageClassName: PropTypes.string,
  hasTokens: PropTypes.bool,
  isBasicAvatar: PropTypes.bool,
  recentSpendingTier: PropTypes.number,
};

TokenHolderIndicatorAvatar.defaultProps = {
  avatarClassName: undefined,
  avatarImageClassName: undefined,
  hasTokens: false,
  isBasicAvatar: false,
  recentSpendingTier: undefined,
};

export default observer(TokenHolderIndicatorAvatar);
